import {HttpClient} from "../../service/httpClient/HttpClient";
import moment from "jalali-moment";
import {doDownloadFile} from "../../util/DownloadHelper";
import {
    convertPersianDateToUniversalDate,
    convertUniversalDateTimeToPersianDateTime
} from "@moeindal/base-raiko-panel-components";

export class CashService {


    constructor(fundID) {
        this.fundID = fundID
        this.httpClient = new HttpClient()
    }


    getCashInfo(fundID) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}`
            ).then(response => resolve(response))
                .catch(reason => reject(reason))
        })
    }


    getAvailableCashList() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                "funds"
            ).then(response => resolve(response))
                .catch(reason => reject(reason))
        })
    }

    prepareFundInfoData(name, muxNumGroup, monthlyMeetingDay, fixedFeeRate, activityStartDate, minimumAmount, lastDay, address, loanRequestEnabled) {
        return {
            "name": name,
            "maximumGroupNumber": muxNumGroup,
            "dateOfMeetingPerMonth": monthlyMeetingDay,
            "fixedFeeRate": fixedFeeRate,
            "minimumAmountReceivedPerMonth": minimumAmount,
            "theLastDayAllowedToReceiveSavingsPerMonth": lastDay,
            "activityStartDate": convertPersianDateToUniversalDate(activityStartDate),
            "postalAddress": address,
            loanRequestEnabled
        }
    }

    updateFundInfo(fundInfo, fundID) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                "funds/" + fundID,
                fundInfo
            ).then(resolve).catch(reject)
        })
    }

    getFundReport(fundID, type) {
        return new Promise((resolve, reject) => {
            this.httpClient.getFile(
                `funds/${fundID}/reports/${type}`
            ).then(resolve).catch(reject)
        })
    }
}